import Vue from 'vue';
import '@progress/kendo-ui/js/kendo.core';
import '@progress/kendo-ui/js/kendo.popup';
import '@progress/kendo-ui/js/kendo.dialog';
import { DialogInstaller } from '@progress/kendo-dialog-vue-wrapper';
import { DropdownsInstaller } from '@progress/kendo-dropdowns-vue-wrapper';

Vue.use(DialogInstaller);
Vue.use(DropdownsInstaller);

export default Vue.component('window', {
  name: 'AddEditForm',
  template: `<kendo-dialog
              ref="dialogRef"
              width="800px"
              :title="title"
              :modal="true"
              :visible="false">
    <div class="add-edit-container">
      <slot></slot>
      <div class="validation-error-list">
        <p v-if="errors.length" class='errorTitle'>Please correct the following error{{errors.length > 1 ? 's' : '' }}:</p>
          <ul>
            <li class="validation-error" v-for="error in errors">{{ error }}</li>
          </ul>
        </p>
      </div>
    </div>
    <kendo-dialog-action text="Save" :primary="true" :action="onSubmit"></kendo-dialog-action>
    <kendo-dialog-action text="Cancel" :action="closeDialog"></kendo-dialog-action>
    <kendo-dialog-action :text="archiveText" :action="onArchive"></kendo-dialog-action>
    <kendo-dialog-action v-show="editMode" text="Delete" :action="onDeleteAttempt"></kendo-dialog-action>
  </kendo-dialog>`,
  data() {
    return {
      errors: [],
      editMode: false,
      isActive: true,
      isDelete: false,
      isSubmitting: false
    };
  },
  methods: {
    onArchive() {
      setTimeout(() => {
        this.sendEvent(!this.isActive);
      }, 100);
      return false;
    },
    onSubmit() {
      if (this.isSubmitting) {
        return false;
      }
      this.isSubmitting = true;

      return this.sendEvent(true)
        .then(() => {
          this.isSubmitting = false;
          return false;
        })
        .catch(() => {
          this.isSubmitting = false;
          return false;
        });
    },
    onDeleteAttempt() {
      // delete precheck
      setTimeout(() => {
        this.isDelete = true;
        this.sendEvent(true, this.isDelete);
      }, 100);
      return false;
    },
    openDialog(e) {
      this.editMode = e.editMode;
      this.errors = [];
      this.isActive = e.isActive;

      const thirdPartyAutoComplete = this.$refs.dialogRef.$children[0];
      thirdPartyAutoComplete.hasError = false;
      thirdPartyAutoComplete.errorMessage = '';

      const { dialogRef } = this.$refs;
      // There must be a race condition on click of this in the Kendo built-in module. Without the timeout, this won't work without clicking a second time
      this.$nextTick(() => {
        dialogRef.kendoWidget().open();
      });
    },
    getAllAutoCompletes(childRef) {
      if (childRef.clearPreserveSearch !== undefined) {
        childRef.clearPreserveSearch();
      }

      childRef.$children.forEach(child => {
        this.getAllAutoCompletes(child);
      });
    },
    closeDialog() {
      setTimeout(() => {
        this.getAllAutoCompletes(this.$refs.dialogRef);
        this.$refs.dialogRef.kendoWidget().close();
        this.$emit('dialog-closed');
      }, 100);
      return false;
    },
    sendEvent(isActive, isDelete = false) {
      return new Promise((resolve, reject) => {
        this.$emit('submit-button-clicked', this.editMode, isActive, isDelete, errors => {
          this.errors = errors;
          if (this.errors.length === 0) {
            this.isActive = isActive;
            if (!this.isDelete) {
              this.closeDialog();
            }
            this.isDelete = false;
            resolve();
          } else {
            reject();
          }
        });
      });
    }
  },
  computed: {
    archiveText() {
      if (this.isActive) {
        // you can't pass in a class into the action dialog, so to set the color, this is the only way I've found to get CSS to style the button on hover
        return 'Archive';
      }
      return 'Unarchive';
    }
  },
  props: ['title']
});
